import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { AlertService } from 'src/app/auth/services/alert.service';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { TidService } from 'src/app/auth/services/tid.service';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { FormField } from 'src/app/_models/form-field';

@Component({
  selector: 'app-check-email',
  templateUrl: './check-email.component.html',
})
export class CheckEmailComponent implements OnInit, OnDestroy {
  @Input() parentForm: FormGroup;

  dialogRef: BsModalRef;
  checkEmailAddressForm: FormGroup;
  private sm = new SubscriptionManager();
  checkEmailAddressField: FormField[];
  isFormValid: boolean;
  isloading = false;
  constructor(
    private tidService: TidService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private authenticationService: AuthenticationService,

    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.checkEmailAddressField = [
      {
        fieldName: 'emailAddress',
        labelName: 'Email Address (Username)',
        fieldType: 'text',
        value: this.tidService.email,
        validations: {
          staticValidations: { required: true, emailPattern: true },
          asyncValidations: { UserNameValidator: true },
        },

        colWidth: 'col-md-12 col-sm-12',
      },
    ];

    this.tidService.isLoading$.subscribe((val) => {
      this.isloading = val;
      this.changeDetectorRef.detectChanges();
    });
    this.sm.manage = (
      this.parentForm.get('checkEmailAddress') as FormGroup
    ).controls.emailAddress.valueChanges.subscribe((res) => {
      if (res.includes(' ')) {
        (
          this.parentForm.get('checkEmailAddress') as FormGroup
        ).controls.emailAddress.setValue((res || '').trim(), {
          emitEvent: true,
        });
      }
    });

    this.sm.manage = this.tidService.errorMessage$.subscribe((error) => {
      this.alertService.error(error, false, 'app-modal-alert', true);
      this.isloading = false;
    });
  }

  redirectTid() {
    const checkEmailAddressControls = (
      this.parentForm.get('checkEmailAddress') as FormGroup
    ).controls;
    const username = checkEmailAddressControls.emailAddress.value;
    this.isloading = true;
    this.authenticationService.resetUser();
    this.sm.manage = this.tidService
      .checkMigrationStatus(username, this.router.url)
      .subscribe();
  }
  isEnterKeyPress(isPress: boolean) {
    if (isPress) {
      this.redirectTid();
    }
  }
  enableContinueButton(isValid: boolean) {
    this.isFormValid = isValid;
  }

  ngOnDestroy(): void {
    this.sm.unsubscribe();
  }
}
